import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { gitlabTranslationRef } from '@immobiliarelabs/backstage-plugin-gitlab';

export const gitlabTranslations = createTranslationResource({
  ref: gitlabTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
  },
});
